
<app-menu></app-menu>

<app-loading></app-loading>

<div class="container">
  <router-outlet></router-outlet>
</div>
